import { Dropdown, Menu, MenuItem, SubMenu } from 'ant-design-vue';
export default {
  name: 'WinActiveMenu',
  components: {
    ADropdown: Dropdown,
    AMenu: Menu,
    AMenuItem: MenuItem,
    ASubMenu: SubMenu
  },
  props: {
    activeKey: {
      type: [String, Number],
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  emits: ['menu-click', 'win-menu-click'],
  setup(props, {
    emit
  }) {
    const handleWinMenuClick = (menu, e) => {
      const {
        path
      } = menu;
      if (!path) return;
      emit('win-menu-click', menu, e);
    };
    const handleMenuClick = menu => {
      emit('menu-click', menu);
    };
    return {
      handleMenuClick,
      handleWinMenuClick
    };
  }
};